module.exports = __webpack_public_path__ + "img/1449694591.14ff9af3.jpg";